import {
  ReportHandler,
  ErrorReporter,
} from 'apps/builder/lib/Honeybadger.js' // used to be .js.erb but it causes deploy issues when core_data_loader was invoked
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  appIDSelector,
  appNameSelector,
  appVersionSelector,
  appStatusSelector,
  lastActionSelector,
} from 'apps/builder/store/selectors'

export const useHoneyBadger = () => {
  const appId = useSelector(appIDSelector)
  const appName = useSelector(appNameSelector)
  const appVersion = useSelector(appVersionSelector)
  const appStatus = useSelector(appStatusSelector)
  const lastAction = useSelector(lastActionSelector)

  useEffect(() => {
    ReportHandler.setContext({
      appName,
      appId,
      appVersion,
      appStatus,
      lastAction,
    })
  }, [appName, appId, appVersion, appStatus, lastAction])

  const notify = e => {
    ErrorReporter(e)
  }

  return [notify]
}
